import React, { useState } from "react";

//CSS
import "./CopyableText.css";

//Functions and hooks
import { useCopyToClipboard } from "../../hooks/useCopyToClipboard";

export default function CopyableText({ children, className = "" }) {
  const copyToClipboard = useCopyToClipboard();
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyClick = () => {
    copyToClipboard(children);
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <span
      className={`copyable-text ${isCopied ? "copied" : ""} ${className}`}
      onClick={handleCopyClick}
      aria-label="Click to copy"
      role="button"
      tabIndex={0}
    >
      <span className="copyable-text-content">{children}</span>
    </span>
  );
}
